<div *ngIf="!notification.customActionId">
  <div class="notification w-full p-4" data-cy="notification-container">
    <p class="p2 my-0 font-semibold" data-cy="notification-text">{{ notification.text }}</p>
    <div *ngIf="notification.buttonLabel1 || notification.buttonLabel2" class="mt-3 flex align-items-center">
      <button
        *ngIf="notification.buttonLabel1"
        pButton
        type="button"
        (click)="responseToNotification(notification.id, 1)"
        class="p-button-outlined flex align-items-center mr-3"
        data-cy="notification-button-1"
        appClickEvent
        eventName="respond_to_notification"
      >
        {{ notification.buttonLabel1 }}
      </button>
      <button
        *ngIf="notification.buttonLabel2"
        pButton
        type="button"
        (click)="responseToNotification(notification.id, 2)"
        class="p-button-outlined flex align-items-center"
        data-cy="notification-button-2"
        appClickEvent
        eventName="respond_to_notification"
      >
        {{ notification.buttonLabel2 }}
      </button>
    </div>
  </div>
</div>
<div *ngIf="notification.customActionId === 'CGM90ENROLL'">
  <p-dialog
    [showHeader]="false"
    [(visible)]="displayCgm90NotificationModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [responsive]="true"
    [closable]="false"
  >
    <h1 class="mt-6 mb-5 text-center">90-day CGM supply orders now available!</h1>
    <p class="p2 my-0">
      CCS Medical can now ship your CGM supplies as a 90-day order instead of a 30-day order. As a Medicare CGM patient,
      you are eligible to enroll in this new program.
    </p>
    <p class="p2 font-semibold mt-5">Benefits to you</p>
    <ul class="p2 mt-3">
      <li>
        <span class="font-semibold">Feel reassured you have what you need when you need it</span>: Receive 90 days of
        CGM supplies every 90 days - instead of 30 days of supplies every 30 days.
      </li>
      <li>
        <span class="font-semibold">Save time</span>: Provide confirmation of supplies on hand every 30 days instead of
        having to place reorders - reduce your reordering from 12X a year 4X a year!
      </li>
      <li>
        <span class="font-semibold">Reduce worry</span>: Fewer shipments means less fretting over possible mail delays.
      </li>
    </ul>
    <p class="p3 mt-4">
      <span class="font-semibold">Note</span>: Claims will still be submitted to Medicare monthly. As a current portal
      user, you will receive email and text notifications from CCS Medical alerting you to monthly claim submission. You
      are required to respond to these monthly notices.
    </p>
    <div class="flex flex-column-reverse justify-content-center mt-5 sm:flex-row w-full">
      <button
        pButton
        label="No thanks"
        [disabled]="(setCgm90EnrollmentState$ | async)?.isLoading"
        type="button"
        (click)="responseToCgm90Enrollment(false, notification.id, false)"
        class="p-button-outlined flex align-items-center m-2"
        data-cy="reject-cgm90-enrollment"
      ></button>
      <button
        pButton
        [label]="
          (setCgm90EnrollmentState$ | async)?.isLoading
            ? 'Updating 90-day Enrollement...'
            : 'Yes! Enroll me in this great benefit!'
        "
        [disabled]="(setCgm90EnrollmentState$ | async)?.isLoading"
        type="button"
        class="p-button flex align-items-center m-2"
        (click)="responseToCgm90Enrollment(true, notification.id, true)"
        data-cy="enroll-in-cgm90"
      ></button>
    </div>
  </p-dialog>
</div>
<div *ngIf="notification.customActionId === 'TEXT_RESPONSE'">
  <div class="notification w-full p-4" data-cy="notification-container">
    <p class="p2 my-0 font-semibold" data-cy="notification-text">{{ notification.text }}</p>
    <div class="mt-3">
      <app-form-field
        [control]="asFormControl(responseForm.get('response'))"
        name="response"
        class="mt-3"
        type="textarea"
        errorLabel="Response"
        [characterLimit]="characterLimit"
        [characterCount]="characterCount"
      ></app-form-field>
    </div>
    <div *ngIf="notification.buttonLabel1 || notification.buttonLabel2" class="mt-3 flex align-items-center">
      <button
        *ngIf="notification.buttonLabel1"
        pButton
        type="button"
        (click)="saveNotificationResponse(notification.id)"
        class="p-button flex align-items-center mr-3"
        data-cy="notification-button-1"
        appClickEvent
        eventName="respond_to_notification"
      >
        {{ notification.buttonLabel1 }}
      </button>
      <button
        *ngIf="notification.buttonLabel2"
        pButton
        type="button"
        (click)="clearNotificationResponse()"
        class="p-button-text flex align-items-center"
        data-cy="notification-button-2"
        appClickEvent
        eventName="clear_notification"
      >
        {{ notification.buttonLabel2 }}
      </button>
    </div>
  </div>
</div>
